var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M6.026 12.449a2.5 2.5 0 0 1-2.5-4.33L6.624 6.33a1 1 0 1 0-1-1.732L2.526 6.387a4.5 4.5 0 0 0 4.5 7.794l3.098-1.789a1 1 0 1 0-1-1.732zm7.036-9.836a2.5 2.5 0 0 1 2.5 4.33l-3.098 1.789a1 1 0 1 0 1 1.732l3.098-1.789a4.5 4.5 0 0 0-4.5-7.794L8.964 2.67a1 1 0 0 0 1 1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#055D7F",
    d: "M13.663 6.308a1 1 0 1 0-1-1.732L5.425 8.754a1 1 0 1 0 1 1.732z"
  }))));
};
export default SvgLink;